import React from "react";
import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import OverlayText from "../../OverlayText/overlayText";
import { LOCALIZATION } from "../../../utils/localization";
import { KeyboardDoubleArrowRight as KeyboardDoubleArrowRightIcon } from "@mui/icons-material";
import { t } from "i18next";
import {
  CALENDAR_ICON,
  TD_VERIFIED_BADGE,
} from "../../../utils/imageConstants";
import templeIcon from "../../../assets/temple-icon.png";
import "./TempleServiceListCard.scss";
import ImageView from "../../ImageView/ImageView";
import BoldText from "../../boldText/BoldText";

export interface TempleServiceListCardProps {
  id?: number;
  templeName: string;
  templeCardImage?: string;
  overlayText: any;
  overlayCss: any;
  serviceThithiName: any;
  selectTemple: (data: any) => void;
  templeData: any;
  serviceDescription: any;
  serviceBenefits: any;
  serviceTitle: any;
  finalTotalPrice: any;
  offerActualPrice: any;
  currencySymbols: any;
  type: any;
  templeAddress?: any;
  showTempleAddress?: Boolean;
  actionLabel: any;
}

export default function TempleServiceListCard({
  templeName,
  templeCardImage,
  overlayText,
  overlayCss,
  serviceThithiName,
  selectTemple,
  templeData,
  serviceDescription,
  serviceBenefits,
  serviceTitle,
  finalTotalPrice,
  offerActualPrice,
  currencySymbols,
  templeAddress = "",
  actionLabel,
}: TempleServiceListCardProps) {
  return (
    <Box
      className="temple-service-card"
      data-scroll-id={`${templeData?.pujaDetails?.id ?? templeData?.id}`}
      onClick={(e: any) => {
        e.stopPropagation();
        selectTemple(templeData);
      }}
    >
      <Box className="service-card-body">
        <Box className="pujaImage">
          {templeCardImage && (
            <ImageView
              src={templeCardImage}
              alt="Chadhava Banner"
              className="bannerImage"
            />
          )}

          {overlayText && (
            <OverlayText
              leftSideTextOverlay={overlayText?.leftSideTextOverlay}
              rightSideTextOverlay={overlayText?.rightSideTextOverlay}
              overlayCss={overlayCss}
            />
          )}
        </Box>
        <Box className="specialTextSection">
          <Box
            component="img"
            className="verifiedBadgeSec"
            src={TD_VERIFIED_BADGE}
            alt="Verified Badge"
          />
          <Typography className="specialTextTitleSec">
            {serviceTitle}
          </Typography>
        </Box>

        <Box className="templeServicecardTitle">
          <Typography className="mainTempleServiceTitle">
            {serviceDescription}
          </Typography>

          {serviceBenefits?.length > 0 && (
            <Typography className="benefitsSubTitle">
              {serviceBenefits.join(" | ")}
            </Typography>
          )}
        </Box>

        <Box className="TempleServiceDescription">
          <List>
            <ListItem>
              <ListItemAvatar sx={{ minWidth: "35px" }}>
                <Avatar className="squreShape temple">
                  <img src={templeIcon} alt="Temple Icon" />
                </Avatar>
              </ListItemAvatar>

              <Typography variant="body1" className="templeNameTextSec">
                {templeName} {templeAddress ? templeAddress : ""}
              </Typography>
            </ListItem>

            {serviceThithiName && (
              <ListItem>
                <ListItemAvatar sx={{ minWidth: "35px" }}>
                  <Avatar alt="Calendar Icon" className="squreShape calendar">
                    <img src={CALENDAR_ICON} alt="calendar"></img>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    serviceThithiName ? (
                      <BoldText text={serviceThithiName || ""} />
                    ) : (
                      ""
                    )
                  }
                  primaryTypographyProps={{
                    className: "serviceThithiText",
                  }}
                />
              </ListItem>
            )}
          </List>
        </Box>
      </Box>
      <Box className="bottomSection">
        {finalTotalPrice > 0 && (
          <Typography className="gstSavingsText">
            {t(LOCALIZATION.GST_TEXT_Card)}
          </Typography>
        )}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
        >
          {finalTotalPrice > 0 && (
            <Stack
              direction="row"
              alignItems="flex-end"
              className="pujaStartPrice"
            >
              <Stack direction="column" className="pujaStartPriceColumn">
                {offerActualPrice > 0 && (
                  <Typography className="cuttedPrice">
                    {currencySymbols}
                    {offerActualPrice}
                  </Typography>
                )}

                <Box display="flex" alignItems="baseline">
                  {finalTotalPrice && (
                    <Typography className="rupeeSign">
                      {currencySymbols}
                    </Typography>
                  )}
                  <Typography className="priceAmount">
                    {finalTotalPrice}
                  </Typography>
                </Box>
              </Stack>

              <Typography ml={1}>{t(LOCALIZATION.Price_Starts)}</Typography>
            </Stack>
          )}

          <Button
            variant="contained"
            endIcon={<KeyboardDoubleArrowRightIcon />}
            className="cardLastBtn"
            onClick={(e: any) => {
              e.stopPropagation();
              selectTemple(templeData);
            }}
          >
            {actionLabel}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
